// extracted by mini-css-extract-plugin
export default {"button":"StatusCritical_button__3I4So"};